import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=007fa7eb&scoped=true"
import script from "./PaymentTable.vue?vue&type=script&lang=js"
export * from "./PaymentTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentTable.vue?vue&type=style&index=0&id=007fa7eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007fa7eb",
  null
  
)

export default component.exports